import { setupI18n } from '@diana/core';
import { resources } from './i18n';

setupI18n({ resources });
